import React, { useState, useEffect } from 'react';
import { Card, Accordion, Form, Row, Col, Button, Spinner, Table, Badge } from 'react-bootstrap'; // Tabs e Tab removidos, Accordion adicionado
import { Bar } from 'react-chartjs-2';
import axios from 'axios';

const RelatoriosPagamentosTab = ({
  currentEntidade, // Necessário para chamadas API
  formatCurrency, // Função de formatação
  isActive, // Propriedade para indicar se a aba está ativa,
  // Novas props para gerenciar ações de convênio
  onMarcarRecebidoClick,
  onMarcarGlosadoClick,
  refreshKey,
}) => {
  // Estados para "Relatório de Pagamentos Recebidos"
  const [pagamentosRecebidosData, setPagamentosRecebidosData] = useState([]);
  const [isLoadingPagamentosRecebidos, setIsLoadingPagamentosRecebidos] = useState(false);
  const [filtroDataInicioPagRecebidos, setFiltroDataInicioPagRecebidos] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0]
  );
  const [filtroDataFimPagRecebidos, setFiltroDataFimPagRecebidos] = useState(
    new Date().toISOString().split('T')[0]
  );

  // Estados para "Relatório de Pagamentos Pendentes"
  const [pagamentosPendentesData, setPagamentosPendentesData] = useState([]);
  const [isLoadingPagamentosPendentes, setIsLoadingPagamentosPendentes] = useState(false);

  // Estados para "Relatório de Inadimplência"
  const [inadimplenciaData, setInadimplenciaData] = useState([]);
  const [isLoadingInadimplencia, setIsLoadingInadimplencia] = useState(false);

  // Estados para "Relatório de Pagamentos por Forma de Pagamento"
  const [pagPorFormaPagamentoData, setPagPorFormaPagamentoData] = useState({ labels: [], datasets: [] });
  const [isLoadingPagPorForma, setIsLoadingPagPorForma] = useState(false);
  const [filtroDataInicioFormaPag, setFiltroDataInicioFormaPag] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0]
  );
  const [filtroDataFimFormaPag, setFiltroDataFimFormaPag] = useState(
    new Date().toISOString().split('T')[0]
  );

  // Estados para "Contas a Receber (Convênios)"
  const [contasReceberConvenioData, setContasReceberConvenioData] = useState([]);
  const [isLoadingContasReceberConvenio, setIsLoadingContasReceberConvenio] = useState(false);
  const [filtroDataInicioConvenio, setFiltroDataInicioConvenio] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0]
  );
  const [filtroDataFimConvenio, setFiltroDataFimConvenio] = useState(
    new Date().toISOString().split('T')[0]
  );
  const [filtroConvenioNome, setFiltroConvenioNome] = useState('');
  const [filtroStatusRecebimento, setFiltroStatusRecebimento] = useState(''); // Pendente, Recebido, Glosa


  // Funções de busca (mantidas aqui)
  const fetchPagamentosRecebidos = async () => {
    if (!filtroDataInicioPagRecebidos || !filtroDataFimPagRecebidos || !currentEntidade) return;
    setIsLoadingPagamentosRecebidos(true);
    try {
      const response = await axios.get('/api/relatorios/pagamentos/recebidos', {
        params: { entidade_id: currentEntidade.id, data_inicio: filtroDataInicioPagRecebidos, data_fim: filtroDataFimPagRecebidos }
      });
      setPagamentosRecebidosData(response.data.dados || []);
    } catch (error) { console.error("Erro ao buscar pagamentos recebidos:", error); setPagamentosRecebidosData([]); }
    finally { setIsLoadingPagamentosRecebidos(false); }
  };

  const fetchPagamentosPendentes = async () => {
    if (!currentEntidade) return;
    setIsLoadingPagamentosPendentes(true);
    try {
      const response = await axios.get('/api/relatorios/pagamentos/pendentes', { params: { entidade_id: currentEntidade.id } });
      setPagamentosPendentesData(response.data.dados || []);
    } catch (error) { console.error("Erro ao buscar pagamentos pendentes:", error); setPagamentosPendentesData([]); }
    finally { setIsLoadingPagamentosPendentes(false); }
  };

  const fetchInadimplencia = async () => {
    if (!currentEntidade) return;
    setIsLoadingInadimplencia(true);
    try {
      const response = await axios.get('/api/relatorios/pagamentos/inadimplencia', { params: { entidade_id: currentEntidade.id } });
      setInadimplenciaData(response.data.dados || []);
    } catch (error) { console.error("Erro ao buscar inadimplência:", error); setInadimplenciaData([]); }
    finally { setIsLoadingInadimplencia(false); }
  };

  const fetchPagPorFormaPagamento = async () => {
    if (!filtroDataInicioFormaPag || !filtroDataFimFormaPag || !currentEntidade) return;
    setIsLoadingPagPorForma(true);
    try {
      const response = await axios.get('/api/relatorios/pagamentos/por-forma', {
        params: { entidade_id: currentEntidade.id, data_inicio: filtroDataInicioFormaPag, data_fim: filtroDataFimFormaPag }
      });
      setPagPorFormaPagamentoData({
        labels: response.data.labels || [],
        datasets: [{ label: 'Faturamento por Forma de Pagamento (R$)', data: response.data.data || [], backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0'], }],
      });
    } catch (error) { console.error("Erro ao buscar pagamentos por forma:", error); setPagPorFormaPagamentoData({ labels: [], datasets: [] }); }
    finally { setIsLoadingPagPorForma(false); }
  };

  // Nova função de busca para contas a receber de convênios
  const fetchContasAReceberConvenio = async () => {
    if (!filtroDataInicioConvenio || !filtroDataFimConvenio || !currentEntidade) return;
    setIsLoadingContasReceberConvenio(true);
    try {
      const params = {
        entidade_id: currentEntidade.id,
        data_inicio: filtroDataInicioConvenio,
        data_fim: filtroDataFimConvenio,
      };
      if (filtroConvenioNome) params.convenio_nome = filtroConvenioNome;
      if (filtroStatusRecebimento) params.status_recebimento = filtroStatusRecebimento;

      const response = await axios.get('/api/relatorios/pagamentos/contas-a-receber-convenio', { params });
      setContasReceberConvenioData(response.data.dados || []);
    } catch (error) {
      console.error("Erro ao buscar contas a receber de convênios:", error);
      setContasReceberConvenioData([]);
    } finally {
      setIsLoadingContasReceberConvenio(false);
    }
  };

  // Efeito para carregar dados quando a aba de Pagamentos é ativada ou filtros mudam
  useEffect(() => {
    if (isActive && currentEntidade) { // Só busca se a aba estiver ativa E a entidade carregada
      fetchPagamentosRecebidos();
      fetchPagamentosPendentes();
      fetchInadimplencia();
      fetchPagPorFormaPagamento();
      fetchContasAReceberConvenio(); // Adiciona a nova busca
    }
  }, [isActive, currentEntidade, filtroDataInicioPagRecebidos, filtroDataFimPagRecebidos, filtroDataInicioFormaPag, filtroDataFimFormaPag, filtroDataInicioConvenio, filtroDataFimConvenio, filtroConvenioNome, filtroStatusRecebimento, refreshKey]); // Adiciona novas dependências e o refreshKey

  const getStatusRecebimentoBadge = (status) => {
    switch (status) {
      case 'Recebido':
        return <Badge bg="success">Recebido</Badge>;
      case 'Glosa':
        return <Badge bg="danger">Glosa</Badge>;
      case 'Pendente':
      default:
        return <Badge bg="warning">Pendente</Badge>;
    }
  };
  return (
    <Accordion defaultActiveKey="0" className="mb-3 custom-accordion-financeiro">
      <Accordion.Item eventKey="0">
        <Accordion.Header>Pagamentos Recebidos</Accordion.Header>
        <Accordion.Body>
          <Card className="mb-0">
            {/* <Card.Header><h4>Relatório de Pagamentos Recebidos</h4></Card.Header> */}
            <Card.Body>
              <Form className="mb-3">
                <Row className="align-items-end">
                  <Col md={4}><Form.Group controlId="filtroDataInicioPagRecebidosTab"><Form.Label>Data Início</Form.Label><Form.Control type="date" value={filtroDataInicioPagRecebidos} onChange={(e) => setFiltroDataInicioPagRecebidos(e.target.value)} /></Form.Group></Col>
                  <Col md={4}><Form.Group controlId="filtroDataFimPagRecebidosTab"><Form.Label>Data Fim</Form.Label><Form.Control type="date" value={filtroDataFimPagRecebidos} onChange={(e) => setFiltroDataFimPagRecebidos(e.target.value)} /></Form.Group></Col>
                  <Col md={2}><Button variant="primary" onClick={fetchPagamentosRecebidos} disabled={isLoadingPagamentosRecebidos}>{isLoadingPagamentosRecebidos ? <Spinner as="span" animation="border" size="sm" /> : 'Filtrar'}</Button></Col>
                  <Col md={2} className="text-end"><Button variant="outline-secondary" size="sm" onClick={() => alert('Exportar CSV não implementado')}>Exportar CSV</Button></Col>
                </Row>
              </Form>
              {isLoadingPagamentosRecebidos ? <div className="text-center"><Spinner animation="border" /></div> : (
                pagamentosRecebidosData.length > 0 ? (
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th className="d-none d-md-table-cell">Data Pag.</th> {/* Oculta em xs e sm */}
                        <th>Paciente</th>
                        <th className="d-none d-md-table-cell">Serviço(s)</th> {/* Oculta em xs e sm */}
                        <th>Valor Pago</th>
                        <th>Forma Pag.</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pagamentosRecebidosData.map(item => (<tr key={item.id}><td className="d-none d-md-table-cell">{item.data_pagamento}</td><td>{item.paciente_nome}</td><td className="d-none d-md-table-cell">{item.servicos_pagos}</td><td>{formatCurrency(item.valor_pago)}</td><td>{item.forma_pagamento}</td><td><Badge bg="success">{item.status_pagamento}</Badge></td></tr>))}
                    </tbody>
                  </Table>
                ) : <p>Nenhum pagamento recebido para o período.</p>
              )}
            </Card.Body>
          </Card>
        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="1">
        <Accordion.Header>Pagamentos Pendentes</Accordion.Header>
        <Accordion.Body>
          <Card className="mb-0">
            {/* <Card.Header><h4>Relatório de Pagamentos Pendentes</h4></Card.Header> */}
            <Card.Body>
              <Button variant="primary" onClick={fetchPagamentosPendentes} disabled={isLoadingPagamentosPendentes} className="mb-3">
                {isLoadingPagamentosPendentes ? <Spinner as="span" animation="border" size="sm" /> : 'Atualizar Lista'}
              </Button>
              {isLoadingPagamentosPendentes ? <div className="text-center"><Spinner animation="border" /></div> : (
                pagamentosPendentesData.length > 0 ? (
                  <Table striped bordered hover responsive>
                    <thead><tr><th>Data Agend.</th><th>Paciente</th><th>Serviço(s)</th><th>Valor Pendente</th><th>Vencimento</th></tr></thead>
                    <tbody>
                      {pagamentosPendentesData.map(item => (<tr key={item.id}><td>{item.data_agendamento}</td><td>{item.paciente_nome}</td><td>{item.servicos_agendados}</td><td>{formatCurrency(item.valor_total_pendente)}</td><td>{item.data_vencimento}</td></tr>))}
                    </tbody>
                  </Table>
                ) : <p>Nenhum pagamento pendente encontrado.</p>
              )}
            </Card.Body>
          </Card>
        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="2">
        <Accordion.Header>Inadimplência</Accordion.Header>
        <Accordion.Body>
          <Card className="mb-0">
            {/* <Card.Header><h4>Relatório de Inadimplência</h4></Card.Header> */}
            <Card.Body>
              <Button variant="primary" onClick={fetchInadimplencia} disabled={isLoadingInadimplencia} className="mb-3">
                {isLoadingInadimplencia ? <Spinner as="span" animation="border" size="sm" /> : 'Atualizar Lista'}
              </Button>
              {isLoadingInadimplencia ? <div className="text-center"><Spinner animation="border" /></div> : (
                inadimplenciaData.length > 0 ? (
                  <Table striped bordered hover responsive>
                    <thead><tr><th>Paciente</th><th>Serviço(s)</th><th>Valor Aberto</th><th>Vencimento Original</th><th>Dias Atraso</th></tr></thead>
                    <tbody>
                      {inadimplenciaData.map(item => (<tr key={item.id}><td>{item.paciente_nome}</td><td>{item.servicos}</td><td>{formatCurrency(item.valor_aberto)}</td><td>{item.data_vencimento_original}</td><td>{item.dias_atraso}</td></tr>))}
                    </tbody>
                  </Table>
                ) : <p>Nenhuma inadimplência encontrada.</p>
              )}
            </Card.Body>
          </Card>
        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="3">
        <Accordion.Header>Por Forma de Pagamento</Accordion.Header>
        <Accordion.Body>
          <Card className="mb-0">
            {/* <Card.Header><h4>Relatório de Pagamentos por Forma de Pagamento</h4></Card.Header> */}
            <Card.Body>
              <Form className="mb-3">
                <Row className="align-items-end">
                  <Col md={4}><Form.Group controlId="filtroDataInicioFormaPagTab"><Form.Label>Data Início</Form.Label><Form.Control type="date" value={filtroDataInicioFormaPag} onChange={(e) => setFiltroDataInicioFormaPag(e.target.value)} /></Form.Group></Col>
                  <Col md={4}><Form.Group controlId="filtroDataFimFormaPagTab"><Form.Label>Data Fim</Form.Label><Form.Control type="date" value={filtroDataFimFormaPag} onChange={(e) => setFiltroDataFimFormaPag(e.target.value)} /></Form.Group></Col>
                  <Col md={2}><Button variant="primary" onClick={fetchPagPorFormaPagamento} disabled={isLoadingPagPorForma} className="mb-3">{isLoadingPagPorForma ? <Spinner as="span" animation="border" size="sm" /> : 'Gerar Gráfico'}</Button></Col>
                </Row>
              </Form>
              {isLoadingPagPorForma ? <div className="text-center"><Spinner animation="border" /></div> : (
                pagPorFormaPagamentoData.labels.length > 0 ? (
                  <div style={{ maxWidth: '400px', margin: 'auto' }}><Bar data={pagPorFormaPagamentoData} /></div>
                ) : <p>Gere o gráfico para visualizar os dados.</p>
              )}
            </Card.Body>
          </Card>
        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="4">
        <Accordion.Header>Contas a Receber (Convênios)</Accordion.Header>
        <Accordion.Body>
          <Card className="mb-0">
            <Card.Body>
              <Form className="mb-3">
                <Row className="align-items-end">
                  <Col md={3}><Form.Group><Form.Label>Data Início</Form.Label><Form.Control type="date" value={filtroDataInicioConvenio} onChange={(e) => setFiltroDataInicioConvenio(e.target.value)} /></Form.Group></Col>
                  <Col md={3}><Form.Group><Form.Label>Data Fim</Form.Label><Form.Control type="date" value={filtroDataFimConvenio} onChange={(e) => setFiltroDataFimConvenio(e.target.value)} /></Form.Group></Col>
                  <Col md={2}><Form.Group><Form.Label>Convênio</Form.Label><Form.Control type="text" placeholder="Nome do convênio" value={filtroConvenioNome} onChange={(e) => setFiltroConvenioNome(e.target.value)} /></Form.Group></Col>
                  <Col md={2}>
                    <Form.Group>
                      <Form.Label>Status</Form.Label>
                      <Form.Select value={filtroStatusRecebimento} onChange={(e) => setFiltroStatusRecebimento(e.target.value)}>
                        <option value="">Todos</option>
                        <option value="Pendente">Pendente</option>
                        <option value="Recebido">Recebido</option>
                        <option value="Glosa">Glosa</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={2}><Button variant="primary" onClick={fetchContasAReceberConvenio} disabled={isLoadingContasReceberConvenio}>{isLoadingContasReceberConvenio ? <Spinner as="span" animation="border" size="sm" /> : 'Filtrar'}</Button></Col>
                </Row>
              </Form>
              {isLoadingContasReceberConvenio ? <div className="text-center"><Spinner animation="border" /></div> : (
                contasReceberConvenioData.length > 0 ? (
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th>Data Atend.</th>
                        <th>Paciente</th>
                        <th>Convênio</th>
                        <th className="text-end">Valor a Receber</th>
                        <th className="text-center">Status</th>
                        <th className="text-center">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {contasReceberConvenioData.map(item => (
                        <tr key={item.pagamento_id}>
                          <td>{item.data_atendimento}</td>
                          <td>{item.paciente_nome}</td>
                          <td>{item.convenio_nome}</td>
                          <td className="text-end">{formatCurrency(item.valor_a_receber)}</td>
                          <td className="text-center">{getStatusRecebimentoBadge(item.status_recebimento)}</td>
                          <td className="text-center">
                            {item.status_recebimento === 'Pendente' && (
                              <>
                                <Button variant="outline-success" size="sm" className="me-1" onClick={() => onMarcarRecebidoClick(item)} title="Marcar como Recebido">Recebido</Button>
                                <Button variant="outline-danger" size="sm" onClick={() => onMarcarGlosadoClick(item)} title="Marcar como Glosa">Glosa</Button>
                              </>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                ) : <p>Nenhuma conta a receber de convênios para o período.</p>
              )}
            </Card.Body>
          </Card>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default RelatoriosPagamentosTab;